__turbopack_context__.v({
  "accordion": "Accordion-module__fAgKBW__accordion",
});
